<template>
    <transition name="modal">
        <div class="modal-backdrop" @click="$emit('close')" @keydown.esc="checkKey($event)">
            <dialog class="modal-item" @click.stop>
                <slot> </slot>
            </dialog>
        </div>
    </transition>
</template>
<script>
export default {
    props: ["show"],
    emits: ["close"],
    data: function() {
        return {};
    },
    methods: {
        checkKey(e) {
            console.log(e);
           
        },
    },
    mounted: function() {
        // document.addEventListener("keydown", (e) => {
        // if (this.show && e.keyCode === 27) {
        // this.$emit("close");
        // }  
        // });
    },
};
</script>
<style lang="scss" scoped>
.modal-backdrop {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(51, 51, 51, 0.45);
  transition: opacity 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-item {
  max-width: 48rem;
  width: 90%;
  max-height: 31rem;
  height: 60%;
  margin: -10rem auto 0;
  padding-bottom: 2.8rem;
  border-radius: .4rem;
  background-color: $white;
  display: block !important;
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06),
      0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
  padding: 2rem;
  border: none;
  @include screen (menner){
    padding: 3.2rem;
    width: 100%;
    height: 100%;
    max-height: 33.6rem;
  }
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>